/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_Blue_Finch_SeeInputs */

const en_clear_blue_finch_see = /** @type {(inputs: Clear_Blue_Finch_SeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible`)
};

const de_clear_blue_finch_see = /** @type {(inputs: Clear_Blue_Finch_SeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichtbar`)
};

/**
* | output |
* | --- |
* | "Visible" |
*
* @param {Clear_Blue_Finch_SeeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const clear_blue_finch_see = /** @type {((inputs?: Clear_Blue_Finch_SeeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_Blue_Finch_SeeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clear_blue_finch_see(inputs)
	return de_clear_blue_finch_see(inputs)
});